import React from "react";
import { Handle } from "reactflow";
import "./BuildChecklistNode.scss";
import { FactCheck } from "@mui/icons-material";
import useVerifyConnection from "../../../../../hooks/useVerifyConnection";

function BuildChecklistNode({ selected }) {
    const verifyConnection = useVerifyConnection();

    return (
        <>
            <Handle
                type="source"
                position="right"
                isValidConnection={verifyConnection}
                id="SUCCESS"
            />
            <div
                className={`build-checklist-node-container${
                    selected ? " selected" : ""
                }`}
            >
                <div className="build-checklist-content">
                    <FactCheck fontSize="large" />
                </div>
            </div>
            <Handle
                type="target"
                position="left"
                isValidConnection={verifyConnection}
            />
        </>
    );
}

export default BuildChecklistNode;
